<template>
	<div id="mapcomponent">
		<div v-if="!cookiesAllowed" class="no-cookies">
			<div class="fa-stack fa-1x">
				<i class="far fa-slash fa-stack-1x" style="color: red;"></i>
				<i class="far fa-cookie-bite fa-stack-1x"></i>
			</div>
			<div>
			<span v-if="currentLang === 'it'">
			  Mappa stradale fornita da OpenStreetMap bloccata in assenza di tua autorizzazione.
			  Per vederla, modifica le tue impostazioni sui cookie
			  e dai il consenso a OpenStreetMap.
			</span>
				<span v-if="currentLang === 'en'">
			  The map provided by OpenStreetMap was blocked, because your authorization is missing.
			  To see it, please update your cookie preferences
			  and allow OpenStreetMap,
			</span>
			</div>
		</div>

		<div v-if="cookiesAllowed">
			<!-- Map holder -->
			<div id="leaflet-container" style="height: 240px; margin-bottom: 2rem;"></div>
		</div>
	</div>
</template>

<script>
import L from 'leaflet/dist/leaflet';
import 'leaflet/dist/leaflet.css';

let map = null;

export default {
	name: 'leaflet',
	data() {
		return {

		}
	},
	props: ['cookiesAllowed', 'currentLang', 'lat', 'lon'],

	// Attention: computed properties are cached!
	computed: {

	},

	// Generic watches, when nothing else fits
	watch: {
		cookiesAllowed: {
			handler: function(val) {
				let self = this;
				console.log('Cookies allowed prop changed: ' + val);
				if(val) {
					self.loadMap();
				}
			},
			immediate: true,
		},
	},

	methods: {
		loadMap: function() {
			let self = this;

			this.$nextTick(function () {
				console.log('Activate map!');

				var southWest = L.latLng(41.845508, 12.568016),
					northEast = L.latLng(41.948368, 12.400732),
					bounds = L.latLngBounds(southWest, northEast);

				map = L.map('leaflet-container', {
					center: [self.lat, self.lon],
					zoom: 14,
					maxBounds: bounds,
					maxZoom: 19,
					minZoom: 12,
				});


				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				}).addTo(map);

				let icon = L.icon({
					iconUrl: '/wp-content/themes/mvmr/src/images/pin_blu_senza_icona.png',
					shadowUrl: '/wp-content/themes/mvmr/src/images/ombra_categorie.png',

					iconSize: [33, 60], // size of the icon
					shadowSize: [38, 6], // size of the shadow
					iconAnchor: [16, 60], // point of the icon which will correspond to marker's location
					shadowAnchor: [16, 3],  // the same for the shadow
					popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
				});
				let marker = L.marker([self.lat, self.lon], {icon: icon}).addTo(map);


			});
		},

	},

	mounted() {
		let self = this;

		let htmlLang = document.getElementsByTagName('html')[0].lang;
		if (!htmlLang || htmlLang === 'it') {
			self.lang = 'it';
		} else {
			self.lang = 'en';
		}

		console.log("Child initial: cookies allowed = " + self.cookiesAllowed);
		if(self.cookiesAllowed === true) {
			self.loadMap();
		}
	}
}
</script>

<style lang="scss">
.no-cookies {
	display: flex;
	align-items: center;

	margin: 0.5em 0;
	border-top: 1px dotted lightgrey;
	padding: 0.5em 0;
	border-bottom: 1px dotted lightgrey;

	.fa-stack {
		font-size: 200%;
		margin-right: 1em;
	}
}

</style>
